"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deregisterPushToken = exports.registerPushToken = void 0;
function registerPushToken(client, opts) {
    return client.post('register_push_token', Object.assign(Object.assign({}, opts.pushToken), { version: opts.appVersion, timezone: opts.timeZone }));
}
exports.registerPushToken = registerPushToken;
function deregisterPushToken(client, opts) {
    return client.post('deregister_push_token', opts.pushToken);
}
exports.deregisterPushToken = deregisterPushToken;
